import classNames from "classnames";

export const PageButton = ({toPrevPage, toNextPage, indx, handlePlace}) => {
    return (
        <div className="prev-next-container">
            <button
                className={classNames('pr-nxt-bt', { "dis": indx === 1 })}
                onClick={toPrevPage}
                disabled={indx === 1}
            >
                Previous
            </button>
            <button
                className={classNames('pr-nxt-bt')}
                onClick={indx === 3 ? handlePlace : toNextPage }
            >
                Next
            </button>
        </div>
    )
}